import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import SideBarLink from '@/layout/components/sidebar/SideBarLink.vue';
import { ref, watch } from 'vue';
import { SidebarLink } from '@/router/sidebarLinksCreator';
import { useDisplay } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarMobile',
  props: {
    sidebarLinks: {},
    lowerSidebarLinks: {},
    isHamburgerOpen: { type: Boolean }
  },
  emits: ["update:isHamburgerOpen"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { smAndDown } = useDisplay();
const localIsHamburgerOpen = ref(false);

//Control sidebar
watch(localIsHamburgerOpen, () => {
  emit('update:isHamburgerOpen', false);
});
watch(
  () => props.isHamburgerOpen,
  () => {
    localIsHamburgerOpen.value = true;
  }
);
watch(smAndDown, () => {
  localIsHamburgerOpen.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(smAndDown))
      ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
          key: 0,
          theme: "dark",
          modelValue: localIsHamburgerOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localIsHamburgerOpen).value = $event)),
          absolute: "",
          temporary: ""
        }, {
          append: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.lowerSidebarLinks, (lowerSidebarLink) => {
                  return (_openBlock(), _createBlock(SideBarLink, {
                    key: lowerSidebarLink.name,
                    "sidebar-link": lowerSidebarLink
                  }, null, 8, ["sidebar-link"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sidebarLinks, (sidebarLink) => {
                  return (_openBlock(), _createBlock(SideBarLink, {
                    key: sidebarLink.name,
                    "sidebar-link": sidebarLink
                  }, null, 8, ["sidebar-link"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})